import React, { useState } from "react";
import { DatePicker, Dropdown, Menu } from "antd";
import { Route, Switch, Link, useHistory} from "react-router-dom";
import { AiOutlineDown } from "react-icons/ai";

import { useListData, useToggle } from "../../modules";
import Receive from "../../components/reusable/receive";
import NewContact from "../../components/drawers/newContact";
import ImportCsv from "../../components/drawers/importCsv";
import Contact from "../../components/drawers/contact";
import moment from "moment";
import Pagination from "../../components/reusable/pagination";

const { RangePicker } = DatePicker;

const Contacts = () => {
  const [ranges, setRanges] = useState();
  const history = useHistory();
  const [string, setString] = useState("");
  const [select, toggleSelect] = useToggle();
  const [chosen, setChosen] = useState([]);
  const [newContactModal, toggleNewContactModal] = useToggle();
  const [importCsvModal, toggleImportCsvModal] = useToggle();

  const [
    { loading: pLoading, error: pError, fetch: fetchContacts },
    { list: contacts },
    { navigate, Paginate, page = 1, limit = 10 }
  ] = useListData('contacts', ranges ? { string, from: ranges[0]?._d ?? null, to: ranges[1]?._d ?? null } : { string }, { notify: true })

  const refetch = () => {
    fetchContacts();
    // navigate(1)
  };

  const refresh  = () => {
    fetchContacts()
    navigate(1)
  }

  const choose = (id) => {
    let temp = [...chosen];

    if (temp.includes(id)) {
      temp = temp.filter((x) => x !== id);
    } else {
      temp.push(id);
    }

    setChosen(temp);
  };

  const togSelect = () => {
    setChosen([]);
    toggleSelect();
  };

  const selectRange = (range) => {
    setRanges(range);
  };

  const search = (str) => {
    setString(str);
    if ((str && str.trim().length > 2) || str.length === 0) {
      refresh()
    }
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
      <div className="flex justify-between items-center mt-1 mb-5">
        <input
          onChange={(e) => search(e.target.value)}
          className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
          id="grid-inv-item"
          type="text"
          placeholder="Search for a contact"
        />
        <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="import-csv">
                <Link to="/app/marketing/contacts/csv">Import CSV</Link>
              </Menu.Item>
              <Menu.Item key="new-contact">
                <Link to="/app/marketing/contacts/new">New Contact</Link>
              </Menu.Item>
            </Menu>
          }
        >
          <button className="btn ml-2 py-2.5 hisani-btn-green-light text-white">
            <svg
              className="w-4 h-4 fill-current opacity-50 flex-shrink-0"
              viewBox="0 0 16 16"
            >
              <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
            </svg>
            <span className="hidden xs:block ml-2">Add Contact</span>
          </button>
        </Dropdown>
        </div>
      </div>
      <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200 px-6 py-4">
        <header className="py-4 border-b border-gray-100 flex justify-between items-center">
          <h2 className="font-semibold text-gray-800"> Contacts </h2>
        </header>
        <Receive error={null} loading={false} progress>
          
          {contacts.length > 0 ? (
            <table className="table-auto w-full">
             
              {/* Table header */}
              <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                <tr>
                  <th className="p-2">
                    <div className="font-semibold text-center">
                      
                      {select ? "Selected" : "No"}
                    </div>
                  </th>
                  <th className="p-2">
                    <div className="font-semibold text-left"> Name </div>
                  </th>
                  <th className="p-2">
                    <div className="font-semibold text-center"> Phone No </div>
                  </th>
                  <th className="p-2">
                    <div className="font-semibold text-center">
                      Email Address
                    </div>
                  </th>
                  <th className="p-2">
                    <div className="font-semibold text-center"> </div>
                  </th>
                </tr>
              </thead>
              {/* Table body */}
              <tbody className="text-sm font-medium divide-y divide-gray-100">
                
                {contacts.map((contact, key) => (
                  <tr key={contact.id}>
                    <td className="p-2">
                      <div className="text-center">
                        
                        {select ? (
                          <input
                            onChange={() => choose(contact)}
                            checked={chosen.some(
                              (cont) => cont._id === contact._id
                            )}
                            type="checkbox"
                            className="form-checkbox cursor-pointer h-5 w-5"
                          />
                        ) : (
                          `${(page - 1) * limit + key + 1}.`
                        )}
                      </div>
                    </td>
                    <td className="p-2">
                      <div className=""> {contact.name} </div>
                    </td>
                    <td className="p-2">
                      <div className="text-center"> {contact.phone} </div>
                    </td>
                    <td className="p-2">
                      <div className="text-center">                       
                        {contact.email}
                      </div>
                    </td>
                    <td className="p-2 text-center">
                      <Dropdown
                        overlay={
                          <Menu>
                            <Link to={`/app/marketing/contacts/${contact._id}`}>
                              <Menu.Item> View </Menu.Item>
                            </Link>
                          </Menu>
                        }
                      >
                        <a
                          className="ant-dropdown-link flex items-center h-10"
                          onClick={(e) => e.preventDefault()}>
                          <span className="mr-2"> Actions </span>
                          <AiOutlineDown />
                        </a>
                      </Dropdown>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="w-full h-16 flex items-center justify-center">
              <p className="font-semibold text-base">
                Please click above to add a new contact
              </p>
            </div>
          )}
        </Receive>
        {Paginate}
      </div>
      <Switch>
        <Route path="/app/marketing/contacts/new">
          <NewContact path="/app/marketing/contacts" onPerform={refetch} />
        </Route>
        <Route path="/app/marketing/contacts/csv">
          <ImportCsv path="/app/marketing/contacts" onPerform={refetch} />
        </Route>
        <Route path="/app/marketing/contacts/:id">
          <Contact path="/app/marketing/contacts" />
        </Route>
      </Switch>
    </div>
  );
};

export default Contacts;
